<template>
    <div id="partners" class="section alter">
        <h1 class="sub-header">{{ $t("partners.header") }}<span class="header-dot">.</span></h1>
        <!-- <div class="header-separator"></div> -->
        <p class="explanation">
            <span>{{ $t("partners.explanation.line-1-1") }}</span>
            <b> 50 </b>
            <span>{{ $t("partners.explanation.line-1-2") }}</span>
            <br>
            <br>
            {{ $t("partners.explanation.line-2") }}
        </p>
        <a href="mailto:info@m2pay.solutions">
            <input class="become-partner-button" type="button" :value="$t('partners.button')">
        </a>
        <div class="content">
            <div class="logo-row">
                <a href="https://adeopos.hr/">
                    <img class="logo-medium" src="../../../assets/images/partners/adeo-pos.png" alt="">
                </a>
                <a href="https://www.remaris.com/">
                    <img class="logo-medium" src="../../../assets/images/partners/remaris.png" alt="">
                </a>
                <a href="https://fiskalna-blagajna.eu">
                    <img class="logo-medium" src="../../../assets/images/partners/fiskal.png" alt="">
                </a>
                <a href="http://holobit.homelinux.com/">
                    <img class="logo-medium" src="../../../assets/images/partners/holobit.png" alt="">
                </a>
                <a href="https://rentl.io/">
                    <img class="logo-medium" src="../../../assets/images/partners/rentlio.png" alt="">
                </a>
                <a href="https://milenij.eu/">
                    <img class="logo-medium" src="../../../assets/images/partners/milenij.svg" alt="">
                </a>
                <a href="https://etranet.hr/">
                    <img class="logo-medium" src="../../../assets/images/partners/etranet.png" alt="">
                </a>
                <a href="https://neoinfo.hr/hr/Pocetna.aspx">
                    <img class="logo-medium" src="../../../assets/images/partners/neoinfo.png" alt="">
                </a>
                <a href="https://utiliter.com/">
                    <img class="logo-medium" src="../../../assets/images/partners/utiliter.png" alt="">
                </a>
                <a href="http://sunx-it.com/">
                    <img class="logo-medium" src="../../../assets/images/partners/sunX.png" alt="">
                </a>
                <a href="https://hoteza.eu/hr/">
                    <img class="logo-medium" src="../../../assets/images/partners/hoteza.png" alt="">
                </a>
                <a href="https://acrelec.com/">
                    <img class="logo-medium" src="../../../assets/images/partners/acrelec.png" alt="">
                </a>
                <a href="https://pronet-kr.si/">
                    <img class="logo-medium" src="../../../assets/images/partners/pronet.png" alt="">
                </a>
                <a href="https://www.maop.si/sl/">
                    <img class="logo-medium" src="../../../assets/images/partners/maop.png" alt="">
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    #partners {
        .explanation {
            b {
                color: var(--signature);
            }
        }

        .become-partner-button {
            margin-top: 50px;
            width: 300px;
            height: 80px;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            background-color: var(--signature);
            box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.5);
            transition: 1s;

            &:hover {
                scale: 1.1;
                background-color: var(--hover);
            }
        }
    }
</style>